/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";
import { Icon, ICON_SIZE } from "../Icon";

/**
 * Component props
 */
export interface IDialogMessageProps {
	title?: string;
	icon?: string;
}

/**
 * Dialog Panel
 * Displays base dialog box.
 * @param props Component props
 */
export const DialogMessage: FC<IDialogMessageProps> = ({ title, icon, children }) => {
	const baseClass = BEM("edt-dialog", "message");

	return (
		<div className={baseClass.toClassName()}>
			{icon ? (
				<Icon
					name={icon}
					size={ICON_SIZE.MEDIUM}
					className={baseClass.element("message-icon").toClassName()}
				/>
			) : null}
			<div className={baseClass.element("message-content").toClassName()}>
				<p className={baseClass.element("message-title").toClassName()}>{title}</p>
				{children}
			</div>
		</div>
	);
};
